import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import { createLogger } from 'redux-logger';
import { isRunningOnClientSide } from '../utils/func';
import rootSaga from './rootSaga';
import rootReducer from './rootReducer';
const sagaMiddleware = createSagaMiddleware();
const loggerMiddleware = createLogger();

let routerMiddlewareCreated;
let composeEnhancers;
let history;

const IS_CLIENT_SIDE = isRunningOnClientSide();
const TYPE_APP = process.env.NODE_APP_TYPE;

if ( IS_CLIENT_SIDE ) {
    const createHistory = ( TYPE_APP === 'ssr' ) ?
        require( 'history' ).createBrowserHistory
        :
        require( 'history' ).createHashHistory;

    history = createHistory();
    routerMiddlewareCreated = routerMiddleware( history );
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

/**
 *
 * @param initialState
 * @returns {boolean|Store<unknown, Action>}
 */
function configureStore( initialState ) {
    return ( process.env.NODE_ENV !== 'production' ) ?
        IS_CLIENT_SIDE &&
        createStore( rootReducer,
            initialState,
            composeEnhancers( applyMiddleware(
                sagaMiddleware,
                routerMiddlewareCreated,
                loggerMiddleware
            ) ) )
        :

        IS_CLIENT_SIDE &&
        createStore( rootReducer,
            initialState,
            composeEnhancers( applyMiddleware( sagaMiddleware, routerMiddlewareCreated ) ) );
}

const store = configureStore();

IS_CLIENT_SIDE && sagaMiddleware.run( rootSaga );

export { history };

export default store;
